import { useSelector } from 'react-redux';
import Global from '../../store/global-selectors';

export const useSupportsMultiPackage = (serviceId) => {
  const service = useSelector((state) => Global.selectSellerServiceById(state, { serviceId })) || {};
  const { features = {} } = service;
  const { supportsMultiPackage = false } = features;
  return supportsMultiPackage;
};
